import { render, staticRenderFns } from "./AppHeroBlock.vue?vue&type=template&id=e74c6a48&scoped=true"
import script from "./AppHeroBlock.vue?vue&type=script&lang=js"
export * from "./AppHeroBlock.vue?vue&type=script&lang=js"
import style0 from "./AppHeroBlock.vue?vue&type=style&index=0&id=e74c6a48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74c6a48",
  null
  
)

export default component.exports